import { Rss } from '@alchemer/ui/icons';
import { Link, useLocation } from '@tanstack/react-router';
import { useState } from 'react';
import { tw } from '@/lib/tailwind';
import { DashboardNavigationItem } from '@/types/';
import SubNav from '../../SubNav/SubNav';

interface NavigationItemProps {
  label: string;
  link: string;
  params?: Record<string, string>;
  subnav?: DashboardNavigationItem[];
}

export default function NavigationItem({ label, link, params, subnav }: NavigationItemProps) {
  const routerLocation = useLocation();
  const isActivePage = link === routerLocation.pathname.replace('/', '');
  const [isSubNavOpen, setIsSubNavOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsSubNavOpen(true);
  };

  const handleMouseLeave = () => {
    setIsSubNavOpen(false);
  };

  return (
    <Link
      params={params}
      to={link}
      className={tw(
        `group hover:border-background-400 hover:bg-background-100 transition-colors`,
        `relative z-20 flex items-center gap-0.5`,
        `border-b border-solid px-2.5 py-2`,
        `${isActivePage ? 'border-background-400' : 'border-transparent'}`,
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Rss
        height={15}
        width={15}
        className={tw(
          `text-muted-foreground`,
          `group-hover:text-accent-foreground group-hover:bg-background-100 transition-colors`,
        )}
      />
      {label}
      {subnav && (
        <SubNav
          page={link}
          subnav={subnav}
          isSubNavOpen={isSubNavOpen}
          setIsSubNavOpen={setIsSubNavOpen}
        />
      )}
    </Link>
  );
}
